import Vue from "vue";
import VueRouter from "vue-router";

import ArticleView from "@/components/pages/ArticleView.vue";
import LoginView from "@/components/pages/LoginView.vue";
import RegisterComponent from "@/components/utils/RegisterComponent.vue";
import ShoppingCart from "@/components/pages/ShoppingCart.vue";
import OrdersPage from "@/components/pages/OrdersPage.vue";
import PartesPage from "@/components/pages/PartesPage.vue";
import Armarios from "@/components/pages/Armarios.vue";
import SoloPlanos from "@/components/pages/SoloPlanos.vue";
import VisorPuente from "@/components/utils/VisorPuente.vue";

// mantenimiento
import MantenimientosPreventivos from "@/components/pages/MantenimientosPreventivos.vue";
import InicioOperario from '@/components/utils/mantenimiento/TrabajosMantenimiento.vue';
import GestionMaquinas from '@/components/utils/mantenimiento/MaquinasMantenimiento.vue';
import GestionFrecuencias from '@/components/utils/mantenimiento/FrecuenciasMantenimiento.vue';
import PlantillasMantenimiento from '@/components/utils/mantenimiento/PlantillasMantenimiento.vue';
import CalendarioLaboral from '@/components/utils/mantenimiento/CalendarioVacaciones.vue';
import HistoricoPlanificacion from '@/components/utils/mantenimiento/PlanificacionMantenimiento.vue';
import AdministradorTareas from '@/components/utils/mantenimiento/AdministradorTareas.vue';
import SubcontratasMantenimiento from "@/components/utils/mantenimiento/SubcontratasMantenimiento.vue";

//Piezas
import Piezas from '@/components/pages/Piezas.vue'

//sin permisos
import SinPermisos from '@/components/pages/views/SinPermisosView.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/sin-permiso",
    name: "sin-permiso",
    component: SinPermisos,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Sin permisos",
          content: "Sin permisos en " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/visor-puente",
    name: "visor-puente",
    component: VisorPuente,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Visor Puente",
          content: "Página del visor de puente de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/mantenimiento",
    name: "mantenimiento",
    component: MantenimientosPreventivos,
    meta: {
      requiresAuth: true,
      hideClientSelector: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Mantenimientos preventivos",
          content: "Página de mantenimientos preventivos de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
    children: [
      {
        path: 'trabajos',
        name: 'mantenimiento-operario',
        component: InicioOperario,
        metaTags: { title: 'Trabajos Pendientes' }
      },
      {
        path: 'admin',
        name: 'mantenimiento-admin',
        component: AdministradorTareas,
        metaTags: { title: 'Administrar Trabajos' }
      },
      {
        path: 'maquinas',
        name: 'mantenimiento-maquinas',
        component: GestionMaquinas,
        metaTags: { title: 'Control de Máquinas' }
      },
      {
        path: 'frecuencias',
        name: 'mantenimiento-frecuencias',
        component: GestionFrecuencias,
        metaTags: { title: 'Frecuencias' }
      },
      {
        path: 'plantillas',
        name: 'mantenimiento-plantillas',
        component: PlantillasMantenimiento,
        metaTags: { title: 'Plantillas de Mantenimiento' }
      },
      {
        path: 'subcontratas',
        name: 'mantenimiento-subcontratas',
        component: SubcontratasMantenimiento,
        metaTags: { title: 'Subcontratas de Mantenimiento' }
      },
      {
        path: 'calendarios',
        name: 'mantenimiento-calendarios',
        component: CalendarioLaboral,
        metaTags: { title: 'Calendario Laboral' }
      },
      {
        path: 'planificacion',
        name: 'mantenimiento-planificacion',
        component: HistoricoPlanificacion,
        metaTags: { title: 'Vista Global e Histórico' }
      }
    ]
  },
  {
    path: "/shop",
    name: "articles",
    component: ArticleView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Página principal",
          content: "Página principal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
    {
    path: "/planos",
    name: "planos",
    component: SoloPlanos,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Página planos",
          content: "Página planos de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      hideClientSelector: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Login",
          content: "Página de Login del portal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/register",
    name: "register",
    component: RegisterComponent,
    meta: {
      hideClientSelector: true,
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Registro",
          content: "Página de Registro del portal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/shopping-cart",
    name: "shopping cart",
    component: ShoppingCart,
    meta: {
      hideClientSelector: true,
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Cesta",
          content: "Cesta de compra de app para " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/orders",
    name: "orders",
    component: OrdersPage,
    meta: {
      hideClientSelector: true,
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Pedidos",
          content: "Página de histórico de pedidos de" + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/armarios",
    name: "cabinets",
    component: Armarios,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "cabinets",
          content: "Lista de armarios de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/piezas",
    name: "piezas",
    component: Piezas,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "piezas",
          content: "Gestión de piezas de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/",
    name: "home",
    // path: "/parts",
    // name: "parts",
    component: PartesPage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Partes",
          content: "Lista de partes de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = `${to.meta.title} - ${to.meta.metaTags[0].name}`;
//   }
//   const loggedIn = localStorage.getItem("token");
//   if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
//     next({name: "login"});
//   }
//   else {
//     next();
//   }
// });
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${to.meta.metaTags[0].name}`;
  }

  const loggedIn = !!localStorage.getItem("token");

  // Acceso por QR: no se permite salir de la ruta del armario (solo cerrando sesión, que quita el bloqueo)
  // (router.app.$store en vez de importar el store: store/modules/api.js ya importa el router)
  if (router.app.$store?.state.bloqueoQR && to.fullPath !== from.fullPath) {
    return next(false);
  }

  // Redirigir al home si está logueado y quiere ir al login
  if (loggedIn && to.name === "login") {
    return next({ name: "home" });
  }

  // Si no está logueado y la ruta requiere auth → login
  if (!loggedIn && to.matched.some(r => r.meta.requiresAuth)) {
    return next({ name: 'login', query: to.query });
  }

  next();
});




export default router;
